/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../_helpers/hooks'
import { handleMessages } from '../../_helpers/utilities'
import Counter from '../../components/counter'
import { errorToast } from '../../slices/toastSlice'
import { voyagerState } from '../../slices/voyagerSlice'
interface ICounterNewBooking {
  seatCount: number
  setCounterError: React.Dispatch<React.SetStateAction<boolean>>
  setSeatCount: React.Dispatch<React.SetStateAction<number>>
  onCountersChange: () => void
  slotAvailability: number
  maxBulkBookings?: number
  disableCounter?: boolean
}

const Counters = (props: ICounterNewBooking) => {
  const {
    seatCount,
    setCounterError,
    setSeatCount,
    slotAvailability,
    onCountersChange,
    maxBulkBookings,
    disableCounter,
  } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { businessConfig } = useAppSelector(voyagerState)

  // In the customer flow, restrict customer bookings to maximum bulk bookings of the facility
  const maxSeatLimit = maxBulkBookings
    ? Math.min(maxBulkBookings, businessConfig?.max_bulk_bookings)
    : businessConfig?.max_bulk_bookings

  useEffect(() => {
    if (slotAvailability > 0 && seatCount > slotAvailability) {
      setSeatCount(slotAvailability)
      dispatch(errorToast(handleMessages(t('newBooking.seatValueExceededSlotAlert'))))
    }
  }, [slotAvailability])

  const handleSeatDecrement = (count: number) => {
    setSeatCount(count)
    onCountersChange()
  }

  const handleSeatIncrement = (count: number) => {
    setSeatCount(count)
    onCountersChange()
  }

  const handleSeatCountOnChange = (value: string) => {
    onCountersChange()
    const newSeatCount = parseInt(value)
    if (slotAvailability) {
      const maxLimit = Math.min(slotAvailability, maxSeatLimit)
      if (newSeatCount > maxLimit) {
        const toastMessage = t('newBooking.selectSeatNumberLimitWithValue', {
          value: maxLimit,
        })
        dispatch(errorToast(handleMessages(toastMessage)))
        setSeatCount(maxLimit)
      } else setSeatCount(newSeatCount)
    } else setSeatCount(newSeatCount)
  }

  useEffect(() => {
    if (seatCount > maxSeatLimit) {
      setCounterError(true)
    } else setCounterError(false)
  }, [seatCount, maxSeatLimit])

  return (
    <Grid container columnSpacing={'1.25rem'}>
      <Grid item xs={12}>
        <Typography variant='subtitle1' color='table.light'>
          {t('newBooking.noOfSeatsTitle')}
        </Typography>

        <Counter
          count={seatCount}
          maxLimit={maxSeatLimit}
          onIncrement={handleSeatIncrement}
          onDecrement={handleSeatDecrement}
          onChange={handleSeatCountOnChange}
          maximumSlotAvailable={slotAvailability}
          disableCounter={disableCounter}
        />
        {seatCount > maxSeatLimit && (
          <Typography variant='caption' color='error.main'>
            {t('newBooking.maxValueValidationWithValue', { value: maxSeatLimit })}
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

export default Counters
